import type { SVGProps } from "react";
import { Ref, forwardRef, memo } from "react";
const SvgMaterialSymbolsTaskAlt = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    ref={ref}
    {...props}
  >
    <path
      fill="currentColor"
      d="M9.975 20q-3.35 0-5.687-2.325T1.95 12t2.338-5.675T9.974 4H14q3.35 0 5.688 2.325T22.025 12t-2.337 5.675T14 20zm.6-6.325L8.45 11.55q-.275-.3-.687-.3t-.713.3-.3.713.3.687l2.475 2.475q.45.45 1.075.45t1.05-.45l5.3-5.3q.3-.275.3-.7t-.3-.7q-.3-.3-.712-.3t-.713.3z"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgMaterialSymbolsTaskAlt);
const Memo = memo(ForwardRef);
export default Memo;
